export default __webpack_public_path__ + "static/media/kitchen1-480w.f8255d1c.avif";